// @flow
import { bambooDataCenter } from 'data/products/bamboo';
import Category from 'model/Category';

export const codeQuality = new Category('code-quality', bambooDataCenter);
